module.exports = __webpack_public_path__ + "static/media/9_r_tram_88.39_55.09.577a30a2.png";